import { Injectable, ErrorHandler } from '@angular/core';
import { AlertService, MessageSeverity } from './services/alert.service';
import { AppInsightsService } from './services/app-insights/appinsights.service';


@Injectable()
export class AppErrorHandler extends ErrorHandler {

    constructor(private alertService: AlertService, private appInsightsService: AppInsightsService) {
        super();
    }

    handleError(error: any) {


        if (this.isLoadChunckError(error)) {
            window.location.reload();
        }
        else if (error.name == 'ObjectUnsubscribedError') {
            console.error(`Caught error => `, error);
        }
        else {
            console.error(`No catched error => `, error);

            this.alertService.showStickyMessage(`Global error occurs`, error.error || error.message, MessageSeverity.error);

            this.appInsightsService.logException(error);

            super.handleError(error);
        }
    }

    private isLoadChunckError(error: any): boolean {
        return /Loading chunk [^\s]+ failed/.test(error.message);
    }

}
